import React, {useEffect, useState} from 'react'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {ModeleReseauClient, modeleReseauClientInitValues} from '../../../components/Models'
import {editReseauClient, getReseauClient} from '../../../components/requests'
import {LoadingData} from '../../../components/LoadingData'
import {ReseauClientForm} from './components/ReseauClientForm'
import Swal from 'sweetalert2'

const ReseauClientEditPage = () => {
  const navigate = useNavigate()
  let {reseauClientId} = useParams()
  const [data, setData] = useState<ModeleReseauClient>(modeleReseauClientInitValues)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getReseauClientsData()
  }, [reseauClientId])

  const getReseauClientsData = () => {
    getReseauClient(reseauClientId)
      .then((reseauClientRequest) => {
        if (reseauClientRequest?.status === 200) {
          if (
            reseauClientRequest?.data?.id !== undefined &&
            reseauClientRequest?.data?.id !== null
          ) {
            const updatedData = Object.assign({...data}, reseauClientRequest?.data)
            setData({...updatedData})
          }
          setLoading(false)
        } else {
          navigate(`/reseau-client`)
        }
      })
      .catch((e) => {
        setLoading(false)
        navigate(`/reseau-client`)
      })
  }

  const submitForm = async (
    fieldsToUpdate: Partial<ModeleReseauClient>,
    callback
  ): Promise<void> => {
    const updatedData = Object.assign({...data}, fieldsToUpdate)
    var requestOk = false
    try {
      const clientRequest = await editReseauClient(reseauClientId, updatedData)
      if (clientRequest?.status === 200) {
        requestOk = true
      }
    }catch (ex: any) {
      if (ex.response?.status === 400) {
        const errorMessage = ex.response?.data?.message || "Ce réseau client existe déjà."
        Swal.fire({
          title: 'Oups',
          text: errorMessage,
          icon: 'warning',
          confirmButtonText: 'OK',
          confirmButtonColor: '#1BC5BD',
        })
      } else {
        console.error(ex)
      }
    } finally {
      callback()
      if (requestOk) {
        setData({...updatedData})
        navigate(`/reseau-client`)
      }
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0 d-flex justify-content-between align-items-center'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Modifier un réseau client</h3>
          </div>
          <Link
            to={`/reseau-client/liste`}
            state={{}}
            data-tooltip-id='tooltip'
            data-tooltip-content='Revenir en arrière'
            data-tooltip-place='right'
          >
            <img src='/media/svg/custom/prev-arrow.svg' width={40} />
          </Link>
        </div>

        <div>
          {loading ? (
            <LoadingData />
          ) : (
            <ReseauClientForm reseauClientId={reseauClientId} data={data} submitForm={submitForm} />
          )}
        </div>
      </div>
    </>
  )
}

export {ReseauClientEditPage}
